<template>
  <div class="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6 flex-wrap">
    <div>
      <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">{{ challenge.title || t("title") }}</h1>
      <p class="mt-1.5 text-sm text-gray-500">
        {{ t("date_range", { startDate: challenge.startDate, endDate: challenge.endDate }) }}
        <span v-if="storeCount">· {{ t("store_count", storeCount) }}</span>
      </p>
    </div>
    <div class="flex gap-2.5 items-center">
      <div class="flex flex-col items-end px-4 py-2 rounded-xl bg-yellow-50 border border-yellow-200">
        <span class="font-semibold uppercase tracking-widest text-yellow-800">
          {{ t("days_remaining_label") }}
        </span>
        <span class="text-2xl font-extrabold text-gray-900 leading-tight">{{ daysRemaining }}</span>
      </div>
      <div class="flex flex-col items-end px-4 py-2 rounded-xl bg-purple-50 border border-purple-100">
        <span class="font-semibold uppercase tracking-widest text-purple-700">
          {{ t("midpoint_label") }}
        </span>
        <span class="text-2xl font-extrabold text-gray-900 leading-tight">
          {{ t("midpoint_value", { elapsed: daysElapsed, total: totalDays }) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { challengeDays } from "@/utils/challengePeriod";

export default {
  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    challenge: {
      type: Object,
      required: true,
    },
    storeCount: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    days() {
      return challengeDays(this.challenge);
    },

    totalDays() {
      return this.days.total;
    },

    daysElapsed() {
      return this.days.elapsed;
    },

    daysRemaining() {
      return this.days.remaining;
    },
  },
};
</script>

<i18n src="./TieredChallengeHeader.i18n.json"></i18n>
